// ── Deep link to "Assign Job Number" ─────────────────────────────────────────
// The Job Number Requested email links Accounting straight to the Turnovers
// list with that turnover's Assign Job Number dialog open:
//   /turnover?assign=<TurnoverID>
// Turnovers.jsx reads the parameter once the list has loaded; this module
// decides what that click should show. Pure.

export const PLATFORM_BASE_URL = "https://estimating.cleanspaceus.com";
export const ASSIGN_PARAM = "assign";

export function assignJobNumberUrl(turnoverId) {
  const id = Number.parseInt(turnoverId, 10);
  return `${PLATFORM_BASE_URL}/turnover${Number.isInteger(id) && id > 0 ? `?${ASSIGN_PARAM}=${id}` : ""}`;
}

export function parseAssignParam(search) {
  const raw = new URLSearchParams(search || "").get(ASSIGN_PARAM);
  const id = Number.parseInt(raw, 10);
  return Number.isInteger(id) && id > 0 ? id : null;
}

// rows: sp_GetTurnovers rows. Returns
//   { state: "open", turnover }              → open the dialog
//   { state: "already_assigned", turnover }  → say so (job number shown)
//   { state: "not_ready", turnover }         → not submitted for a number yet
//   { state: "not_found" }
export function resolveAssignTarget(rows, turnoverId) {
  const t = (rows || []).find(r => Number(r.TurnoverID) === Number(turnoverId));
  if (!t) return { state: "not_found" };
  if (t.Status === "Pending Number") return { state: "open", turnover: t };
  if (t.JobNumber) return { state: "already_assigned", turnover: t };
  return { state: "not_ready", turnover: t };
}
